/*
  Ambient audio controller
    turns arrays of file names into looping ambient audio tracks
*/
// import audioMixer from 'helios-audio-mixer'

import { Howl, Howler } from 'howler'
import { getPositionForYaw } from 'panorama/helpers/pano-helpers'

let trackList = []

export const tracks = (data, replace) => {
  const sources = data.map(track => track.src)

  trackList
    .filter(track => sources.indexOf(track.src) === -1)
    .forEach(track => {
      track.sound.once('fade', id => track.sound.stop(id), track.id)
      track.sound.fade(track.sound.volume(), 0, 1000, track.id)
    })

  data.forEach(trackData => {
    // if (!trackList[trackData.id]) {
    let track = trackList.find(s => s.src === trackData.src)

    if (track) {
      track.sound.play(track.id)
    } else {
      const src = trackData.src
      const sound = new Howl({
        src: [src],
        volume: 0,
        loop: trackData.loop || true,
        onloaderror: () => {
          console.log('CAN NOT LOAD')
        },
        onplayerror: () => {
          console.log('AUTO PLAY ERROR')
        }
      })

      const id = sound.play()
      track = { id, sound, src }

      if (trackData.position) {
        track.position = trackData.position
      }

      trackList.push(track)
    }

    track.sound.fade(0, trackData.volume || 1, 1000)
  })

  return trackList
}

export const setPosition = (tracks, yaw) => {
  tracks.forEach(track => {
    const pos = getPositionForYaw(track.position, yaw)
    track.sound.pos(pos.x, 0, 2 - pos.z * 2, track.id)
  })
}

export default { tracks }
